const checkboxTrueValue = '1';

const paramToBool = (value) => value === checkboxTrueValue || value === true;

export default paramToBool;
